export const findDigiType = (digiTypeList, typeId) => digiTypeList.find(type => type.id === typeId);
